<!--
This is designed to be a reusable component work with a Sharepoint List.
It can take just a listId, or a ListId and an ItemId
-->
<template>
  <div v-loading="loading" element-loading-spinner="particle-loader">
    <span class="el-breadcrumb" aria-label="Breadcrumb" role="navigation">
      <span class="el-breadcrumb__item" v-for="(breadCrumb, index) in fileBreadCrumbs" :key="breadCrumb.itemId"
        @click="navigateToFolder({ id: breadCrumb.itemId, name: breadCrumb.name, folder: { childCount: breadCrumb.childCount }}, false)">
        <span :class="['el-breadcrumb__inner', (index !==  fileBreadCrumbs.length -1) ? 'is-link' : '']">
          {{ breadCrumb.name + ' (' + breadCrumb.childCount + ')' }}
          <span v-if="(index !==  fileBreadCrumbs.length -1)" class="el-breadcrumb__separator"
            role="presentation">{{ '/' }}</span>
        </span>
      </span>
    </span>
    <el-row v-if="!loading">
      <a id="hiddenAnchor" style="display: none;"></a>
      <el-col :span="20" style=" margin-bottom: 50px;">
        <el-table ref="documentTable" id="documentTable" :data="documents" @selection-change="handleSelectionChange"
          :height="documents.length > 8 ? '55vh' : 'auto'">
          <el-table-column type="selection" width="35">
          </el-table-column>
          <el-table-column sortable prop="name" label="Name" min-width="200" class-name="document-item">
            <template slot-scope="scope">
              <div v-if="scope.row.folder" class="item">
                <el-row :span="24">
                  <el-col :span="2">
                    <i @click="navigateToFolder(scope.row, true)" class="mdi mdi-folder folderIcon"></i>
                  </el-col>
                  <el-col :span="22">
                    <span v-if="showFileFolderNameInput !== scope.row.id" @click="navigateToFolder(scope.row, true)"
                      class="docName">{{scope.row.name + ((scope.row.folder) ? ' (' + scope.row.folder.childCount + ')' : '')}}</span>
                    <el-input v-if="showFileFolderNameInput === scope.row.id"
                      :class="'documentTableInput_'+scope.row.id" placeholder="Please input" v-model="newFileFolderName"
                      @blur="putEditFileFolerName(scope.row)">
                    </el-input>
                  </el-col>
                </el-row>
              </div>
              <div v-else class="item">
                <el-row :span="24">
                  <el-col :span="2">
                    <i @click="openFile(scope.row.webUrl)"
                      :class="'mdi '+handleExtensionIcon(scope.row)+' docIcon'"></i>
                  </el-col>
                  <el-col :span="22">
                    <span v-if="showFileFolderNameInput!== scope.row.id"
                      @click="openFile(scope.row.webUrl)">{{scope.row.name}}</span>
                    <el-input v-if="showFileFolderNameInput === scope.row.id"
                      :class="'documentTableInput_'+scope.row.id" placeholder="Please input" v-model="newFileFolderName"
                      @blur="putEditFileFolerName(scope.row)">
                    </el-input>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" width="40">
            <template slot-scope="scope">
              <el-dropdown style="float: left;" trigger="click" @command="actionMenuCommands" size="medium">
                <span class="el-dropdown-link">
                  <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 150px;" class="documentActionMenu">
                  <el-dropdown-item :command="{scope: scope, action: 'open'}"><i
                      class="mdi mdi-open-in-new documentActionMenuIcon"></i>Open</el-dropdown-item>
                  <el-dropdown-item :command="{scope: scope, action: 'move'}" v-if="!scope.row.folder"><i
                      class="mdi mdi-file-replace-outline documentActionMenuIcon" v-if="!scope.row.folder"></i>Move
                  </el-dropdown-item>
                  <el-dropdown-item :command="{scope: scope, action: 'rename'}"><i
                      class="mdi mdi-cursor-text documentActionMenuIcon"></i>Rename</el-dropdown-item>
                  <el-dropdown-item :command="{scope: scope, action: 'delete'}"><i
                      class="mdi mdi-delete-outline documentActionMenuIcon"></i>Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column sortable prop="created" label="Created">
            <template slot-scope="scope">
              {{ scope.row.createdDateTime }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="creatorName" label="Creator">
            <template slot-scope="scope">
              {{ scope.row.createdBy.user ? scope.row.createdBy.user.displayName : scope.row.createdBy.application.displayName }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="modified" label="Modified">
            <template slot-scope="scope">
              {{ scope.row.lastModifiedDateTime }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="modifiedBy" label="Modified By">
            <template slot-scope="scope">
              {{ scope.row.lastModifiedBy.user ? scope.row.lastModifiedBy.user.displayName : scope.row.lastModifiedBy.application.displayName }}
            </template>
          </el-table-column>
        </el-table>
        <div id="documentTableStats">
          <p>{{documentTableStats()}}</p>
        </div>
      </el-col>
      <el-col :span="4" style="margin-top: 30px;">
        <ul class="actionButtons">

          <li v-if="loadMoreActive" @click="loadMore">
            <div class="actionButtonsItem"><span><i class="mdi mdi-reload actionButtonsIcon"></i>
                Load More</span></div>
          </li>

          <li @click="openFile(getLastItemFromBreadCrumbs().webUrl)">
            <div class="actionButtonsItem"><span><i class="mdi mdi-open-in-new actionButtonsIcon"></i> Open
                Folder</span></div>
          </li>

          <li @click="newFolderDialogVisible = true">
            <div class="actionButtonsItem"><span><i class="mdi mdi-folder-plus-outline actionButtonsIcon"></i> New
                Folder</span></div>
          </li>
          <li @click="openUploadDialog">
            <div class="actionButtonsItemActive"><i style="font-size: 18px;"
                class="mdi mdi-file-upload-outline actionButtonsIcon"></i> Upload Files</div>
            <input id="fileUpload" style="display: none;" name="txttoImport" type="file" @change="handleFileUpload"
              multiple>
          </li>
          <li v-if="selectedRows.filter(x => !x.isFolder).length > 0" @click="openMoveDialog">
            <div class="actionButtonsItem"><span><i class="mdi mdi-file-replace-outline actionButtonsIcon"></i>
                Move</span></div>
          </li>
          <li v-if="selectedRows.length === 1" @click="editFileFolderName(0, selectedRows[0])">
            <div class="actionButtonsItem"><span><i class="mdi mdi-cursor-text actionButtonsIcon"></i> Rename</span>
            </div>
          </li>
          <li v-if="selectedRows.length > 0" @click="deleteSelected">
            <div class="actionButtonsItem"><span><i class="mdi mdi-delete-outline actionButtonsIcon"></i> Delete</span>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-dialog title="Create New Folder" :visible.sync="newFolderDialogVisible" width="50%"
      :before-close="closeNewFolderDialog" :append-to-body="true">
      <el-form label-position="top" @submit.prevent.native>
        <el-form-item label="New Folder Name">
          <el-input type="text" v-model="newFolderName" @keydown.enter.native="createNewFolder" maxlength="100">
          </el-input>
          <span><small style="position: absolute; bottom: -30px; left: 0px;">{{invalidFolderMessage()}}</small></span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNewFolderDialog">Cancel</el-button>
        <el-button :disabled="newFolderName && invalidFolderMessage().length > 0" type="primary"
          @click="createNewFolder">Create
          Folder</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="fileOperationsDialogTitle" :visible.sync="fileOperationsDialogVisible" width="50%"
      :before-close="closeFileOperationsDialog" :append-to-body="true">
      <el-table :data="filesToOperateOn" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="name" label="" min-width="200" class-name="document-item">
        </el-table-column>
        <el-table-column prop="statusMessage" label="" min-width="80">
        </el-table-column>
        <!-- <el-table-column prop="loadingStatus" align="center" label="" min-width="30">
          <template slot-scope="scope">
            <i style="font-size: 15px;" v-if="scope.row.loadingStatus === 'loading'" class="el-icon-loading"></i>
            <i style="font-size: 15px; color: green;" v-if="scope.row.loadingStatus === 'done'"
              class="el-icon-circle-check"></i>
            <i style="font-size: 15px; color: red;" v-if="scope.row.loadingStatus === 'error'"
              class="el-icon-error"></i>
          </template>
        </el-table-column> -->
        <el-table-column prop="percentCompleted" label="" min-width="30">
          <template slot-scope="scope">
            <el-progress type="circle" :percentage="scope.row.percentCompleted" :status="scope.row.progressStatus"
              :width="45" :color="scope.row.progressColor">
              {{scope.row.progressStatus === 'text' ? `${scope.row.percentCompleted}%` : ''}}
            </el-progress>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFileOperationsDialog">Close</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="moveMessage" :visible.sync="moveDialogVisible" width="50%" :before-close="closeMoveDialog"
      :append-to-body="true">
      <onedriveFolderPicker :listId="listId" :itemId="itemId" :listName="root.name" :fileBreadCrumbs="fileBreadCrumbs">
      </onedriveFolderPicker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMoveDialog">Cancel</el-button>
        <el-button type="primary" @click="moveSelectedParticle">Move</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import onedriveFolderPicker from '@/components/onedrive/onedriveFolderPicker'

  export default {
    name: 'onedriveList',
    props: {
      listId: String,
      // listName: String,
      itemId: {
        type: String,
        default: null
      }
    },
    // mixins: [dateHelper],
    components: {
      onedriveFolderPicker
    },
    data() {
      return {
        fileBreadCrumbs: [],
        loading: true,
        parentDirectoryNavigation: '/',
        filesToOperateOn: [],
        newFolderDialogVisible: false,
        moveDialogVisible: false,
        moveDialogLoading: false,
        moveMessage: '',
        moveToDirectory: null,
        moveToBreadcrumbs: [],
        fileOperationsDialogVisible: false,
        fileOperationsDialogTitle: '',
        newFolderName: '',
        selectedRows: [],
        zipFile: {},
        newFileFolderName: '',
        showFileFolderNameInput: 0,
        root: {
          itemId: '',
          name: '',
          webUrl: ''
        },
        separator: '|'
      }
    },
    methods: {
      ...mapActions('onedrive/', ['GET_DOCUMENTS', 'POST_FOLDER', 'POST_FILE', 'DELETE_FILE', 'RENAME_ITEM', 'GET_ITEMID_FORLIST', 'MOVE_ITEM', 'GET_ITEM', 'MOVE_ITEM_PARTICLE']),
      initialize() {
        this.loading = true
        let payload = {
          listId: this.listId,
          itemId: this.itemId
        }
        let nameTask
        if (this.itemId === null) {
          nameTask = this.GET_ITEMID_FORLIST(this.listId)
        } else {
          nameTask = this.GET_ITEM(payload)
        }

        Promise.all([nameTask, this.GET_DOCUMENTS(payload)]).then(response => {
          this.root.itemId = response[0].id
          this.root.name = response[0].name
          this.root.webUrl = response[0].webUrl
          payload.childCount = response[0].folder.childCount
          if (this.itemId === null) {
            payload.itemId = this.root.itemId
          }
          payload.name = this.root.name
          payload.webUrl = this.root.webUrl
          this.setFileBreadCrumbs(payload, false)
          this.loading = false
        })
      },
      setFileBreadCrumbs(payload, levelDown) {
        if (levelDown) {
          // clicking the table and going down - add new breadcrumb
          this.fileBreadCrumbs.push(payload)
        } else {
          // from breadcrump - find clicked item, and remove all after it
          // special check for Home
          if (payload.itemId === this.root.itemId) {
            let home = {
              listId: this.listId,
              itemId: this.root.itemId,
              name: this.root.name,
              childCount: payload.childCount,
              webUrl: payload.webUrl
            }
            this.fileBreadCrumbs = []
            this.fileBreadCrumbs.push(home)
          } else {
            let len = this.fileBreadCrumbs.length
            for (var i = 0; i <= len - 1; i++) {
              if (this.fileBreadCrumbs[i].itemId === payload.itemId) {
                this.fileBreadCrumbs.splice(i + 1)
                break
              }
            }
          }
        }
      },
      navigateToFolder(item, levelDown) {
        this.loading = true
        let payload = {
          listId: this.listId,
          itemId: item.id,
          name: item.name,
          childCount: item.folder.childCount,
          webUrl: item.webUrl
        }
        this.GET_DOCUMENTS(payload).then(() => {
          this.setFileBreadCrumbs(payload, levelDown)
          this.loading = false
        })
      },
      openUploadDialog() {
        document.getElementById('fileUpload').click()
      },
      postFilesRecursive(filesToUpload, i) {
        return new Promise((resolve) => {
          filesToUpload[i].loadingStatus = 'loading'
          filesToUpload[i].statusMessage = 'uploading...'

          if (i === 0) {
            this.fileOperationsDialogTitle = 'Upload Details'
            this.fileOperationsDialogVisible = true
          }

          this.POST_FILE(filesToUpload[i]).then(() => {
            filesToUpload[i].loadingStatus = 'done'
            filesToUpload[i].statusMessage = 'done'

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          }, error => {
            filesToUpload[i].loadingStatus = 'error'
            if (error.response) {
              filesToUpload[i].statusMessage = error.response.data.message
            }

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          })
        })
      },
      handleFileUpload(e) {
        this.filesToOperateOn = []
        let tempFiles = e.target.files
        const totalCount = tempFiles.length
        if (totalCount > 0) {
          this.loading = true
          for (let i = 0; i < totalCount; i++) {
            this.filesToOperateOn.push({
              attachment: tempFiles[i],
              name: tempFiles[i].name,
              directory: this.parentDirectoryNavigation,
              listId: this.listId,
              itemId: this.fileBreadCrumbs[this.fileBreadCrumbs.length - 1].itemId,
              statusMessage: '',
              loadingStatus: ''
            })
          }
          this.postFilesRecursive(this.filesToOperateOn, 0).then(() => {
          })
        }
      },
      deleteRecursive(itemsToDelete, i) {
        itemsToDelete[i].loadingStatus = 'loading'
        itemsToDelete[i].statusMessage = 'deleting...'

        if (i === 0) {
          this.fileOperationsDialogTitle = 'Delete Details'
          this.fileOperationsDialogVisible = true
        }

        this.DELETE_FILE(itemsToDelete[i]).then(() => {
          itemsToDelete[i].loadingStatus = 'done'
          itemsToDelete[i].statusMessage = 'done'

          if (i === itemsToDelete.length - 1) {
            this.loading = false
            this.selectedRows = []
          } else {
            this.deleteRecursive(itemsToDelete, i + 1)
          }
        }, error => {
          itemsToDelete[i].loadingStatus = 'error'
          if (error.response) {
            itemsToDelete[i].statusMessage = error.response.data.message
          }

          if (i === itemsToDelete.length - 1) {
            this.loading = false
          } else {
            this.deleteRecursive(itemsToDelete, i + 1)
          }
        })
      },
      openMoveDialog() {
        this.moveMessage = this.selectedRows.length === 1 ? 'Move 1 file to...' : `Move ${this.selectedRows.length} files to...`
        this.moveDialogVisible = true
        this.moveDialogLoading = true
      },
      moveRecursive(itemsToMove, i, moveToDirectory) {
        itemsToMove[i].loadingStatus = 'loading'
        itemsToMove[i].statusMessage = 'moving...'

        if (i === 0) {
          this.fileOperationsDialogTitle = 'Move Details'
          this.fileOperationsDialogVisible = true
          this.$nextTick(() => {
            this.moveDialogVisible = false
          })
        }

        this.MOVE_ITEM(itemsToMove[i]).then(() => {
          itemsToMove[i].loadingStatus = 'done'
          itemsToMove[i].statusMessage = 'done'

          if (i === itemsToMove.length - 1) {
            this.loading = false
            let lastCrumb = this.getLastItemFromBreadCrumbs()
            // console.log(lastCrumb)
            let item = {
              listId: this.listId,
              itemId: lastCrumb.itemId
            }
            this.loading = true
            Promise.all([this.GET_ITEM(item), this.GET_DOCUMENTS(item)]).then((response) => {
              // update breadcrumbs with new itemInfo
              let replacementCrumb = {
                listId: this.listId,
                itemId: lastCrumb.itemId,
                childCount: response[0].folder.childCount,
                name: response[0].name
              }
              this.fileBreadCrumbs[this.fileBreadCrumbs.length - 1] = replacementCrumb
              this.loading = false
            })
            this.selectedRows = []
          } else {
            this.moveRecursive(itemsToMove, i + 1)
          }
        }, error => {
          itemsToMove[i].loadingStatus = 'error'
          if (error.response) {
            itemsToMove[i].statusMessage = error.response.data.message
          }

          if (i === itemsToMove.length - 1) {
            this.loading = false
          } else {
            this.moveRecursive(itemsToMove, i + 1)
          }
        })
      },
      moveSelected() {
        this.filesToOperateOn = []
        for (let i = 0; i < this.selectedRows.length; i++) {
          this.filesToOperateOn.push({
            itemId: this.selectedRows[i].id,
            listId: this.listId,
            statusMessage: '',
            loadingStatus: ''
          })
        }

        // this.moveRecursive(this.filesToOperateOn, 0, this.selectedItemId)
      },
      getLastItemFromBreadCrumbs() {
        return this.fileBreadCrumbs[this.fileBreadCrumbs.length - 1]
      },
      deleteSelected() {
        let message = ''
        if (this.selectedRows.length > 1) {
          message = `Are you sure you want to delete ${this.selectedRows.length} items?`
        } else if (this.selectedRows.length === 1) {
          message = `Are you sure you want to delete ${this.selectedRows[0].name}?`
        }

        this.$confirm(message, 'Delete items', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.filesToOperateOn = []
          // copy into a reactive array with some additional properties
          for (let i = 0; i < this.selectedRows.length; i++) {
            this.filesToOperateOn.push({
              name: this.selectedRows[i].name,
              id: this.selectedRows[i].id,
              listId: this.listId,
              itemId: this.selectedRows[i].id,
              statusMessage: '',
              loadingStatus: ''
            })
          }

          this.loading = true
          this.deleteRecursive(this.filesToOperateOn, 0)
        })
      },
      closeMoveDialog() {
        this.moveDialogVisible = false
      },
      closeNewFolderDialog() {
        this.newFolderDialogVisible = false
        this.newFolderName = ''
      },
      closeFileOperationsDialog() {
        this.fileOperationsDialogTitle = ''
        this.fileOperationsDialogVisible = false
        this.fileToOperateOn = []
      },
      createNewFolder() {
        if (!this.newFolderName) {
          return
        }

        let payload = {
          name: this.newFolderName,
          listId: this.listId,
          itemId: this.fileBreadCrumbs[this.fileBreadCrumbs.length - 1].itemId // get the last item Id in the breadcrumb
        }
        this.POST_FOLDER(payload).then(response => {
          this.navigateToFolder(response, true)
          this.newFolderName = null
          this.newFolderDialogVisible = false
        }, error => {
          this.showErrorMessage(error)
          console.log(error)
          this.newFolderDialogVisible = false
        })
      },
      invalidFolderMessage() {
        if (/[\\/:*?""<>|]/.test(this.newFolderName)) {
          return `Folder name may not contain any of \\ / : * ? "< > |`
        }
        return ''
      },
      formatDate(sourceDate) {
        // return format(sourceDate, 'M/D/YYYY hh:mm A')
        return sourceDate
      },
      handleSelectionChange(val) {
        this.selectedRows = val
      },
      putEditFileFolerName(row) {
        // revert back to normal; make put if different
        this.showFileFolderNameInput = 0
        this.loading = true
        let tempName = row.name.indexOf('.') !== -1 ? row.name.split('.').slice(0, -1).join() : row.name
        if (tempName !== this.newFileFolderName) {
          // get ext if file and add it
          let ext = row.name.indexOf('.') !== -1 ? '.' + row.name.split('.').pop() : ''
          // build payload; call put
          let payload = {
            listId: this.listId,
            itemId: row.id,
            newName: this.newFileFolderName + ext
          }
          this.RENAME_ITEM(payload).then(response => {
            // this.showSuccessMessage('Rename Successful')
            this.loading = false
          }, error => {
            // this.showErrorMessage(error)
            console.log(error)
          })
        }
        // reset
        this.newFileFolderName = ''
      },
      editFileFolderName(index, row) {
        // hide name; show input; focus input; local variable to current name; remove ext if file
        this.showFileFolderNameInput = row.id
        this.$nextTick(() => {
          let input = document.querySelector('.documentTableInput_' + row.id)
          input.querySelector('input').focus()
          // set local variable to current name; remove ext if file
          this.newFileFolderName = row.name.indexOf('.') !== -1 ? row.name.split('.').slice(0, -1).join() : row.name
        })
      },
      actionMenuCommands(object) {
        if (object.action === 'open') {
          window.open(object.scope.row.webUrl)
        }
        if (object.action === 'download') {
          this.getDownloadLink(object.scope.row.id)
        }
        if (object.action === 'move') {
          this.$refs.documentTable.clearSelection()
          this.$refs.documentTable.toggleRowSelection(object.scope.row)
          this.openMoveDialog()
        }
        if (object.action === 'delete') {
          this.$refs.documentTable.clearSelection()
          this.$refs.documentTable.toggleRowSelection(object.scope.row)
          this.deleteSelected()
        }
        if (object.action === 'rename') {
          this.editFileFolderName(object.scope.$index, object.scope.row)
        }
      },
      handleExtensionIcon(row) {
        let fileName = row.name
        let ext = (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : undefined
        let icon = 'file'

        // special handler for oneNote
        if (row.package) {
          if (row.package.type === 'oneNote') {
            ext = 'on'
          }
        }

        if (this.fileAccept.some(x => x.ext === ext)) {
          icon = this.fileAccept.filter(x => x.ext === ext).map(y => y.icon)[0]
        } else {
          icon = 'mdi-file-document-box-outline'
        }
        return icon
      },
      documentTableStats() {
        let childCount = this.getLastItemFromBreadCrumbs().childCount
        let suffix = ' / ' + childCount
        let prefix = ''
        // let actualCount = this.documents.length
        if (this.documents.filter(f => f.isFolder).length > 0) {
          prefix = `${this.documents.filter(f => f.isFolder).length} Directories and ${this.documents.filter(f => !f.isFolder).length} Documents`
        } else {
          prefix = `${this.documents.filter(f => !f.isFolder).length} Documents`
        }

        return prefix + suffix
      },
      loadMore() {
        // pass in skip value for GET_DOCUMENTS
        this.loading = true
        let payload = {
          listId: this.listId,
          itemId: this.getLastItemFromBreadCrumbs().itemId,
          nextLink: this.nextLink
        }
        this.GET_DOCUMENTS(payload).then(() => {
          this.loading = false
        })
      },
      openFile(url) {
        // console.log(url)
        // eslint-disable-next-line
        appInsights.trackEvent('ONEDRIVE_FILEOPEN', { file: url, username: JSON.stringify(window.user) })
        window.open(url)
      },
      openMoveDialogParticle(payload) {
        this.moveMessage = payload.moveMessage
        this.moveDialogVisible = true
        this.moveDialogLoading = true
        this.selectedRows = payload.selectedRows
      },
      moveSelectedParticle() {
        this.filesToOperateOn = []
        for (let i = 0; i < this.selectedRows.length; i++) {
          this.filesToOperateOn.push({
            name: this.selectedRows[i].name,
            itemId: this.selectedRows[i].id,
            listId: this.listId,
            statusMessage: '',
            loadingStatus: '',
            directoryId: this.selectedItemId,
            percentCompleted: 0,
            onUploadProgress: {},
            progressStatus: 'text',
            progressColor: '#7CBE5F'
          })
        }
        this.moveRecursiveParticle(this.filesToOperateOn, 0, this.selectedItemId)
      },
      moveRecursiveParticle(itemsToMove, i, moveToDirectory) {
        itemsToMove[i].loadingStatus = 'loading'
        itemsToMove[i].statusMessage = 'moving...'

        itemsToMove[i].onUploadProgress = (progressEvent) => {
          itemsToMove[i].percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          if (itemsToMove[i].percentCompleted >= 90) {
            itemsToMove[i].percentCompleted = 90
            itemsToMove[i].statusMessage = 'almost done...'
          }
        }

        if (i === 0) {
          this.fileOperationsDialogTitle = 'Move Details'
          this.fileOperationsDialogVisible = true
          this.$nextTick(() => {
            this.moveDialogVisible = false
          })
        }

        this.MOVE_ITEM_PARTICLE(itemsToMove[i]).then(() => {
          itemsToMove[i].loadingStatus = 'done'
          itemsToMove[i].statusMessage = 'done'
          itemsToMove[i].progressStatus = 'success'
          itemsToMove[i].percentCompleted = 100

          if (i === itemsToMove.length - 1) {
            // this.initialize()
            this.loading = false
            let lastCrumb = this.getLastItemFromBreadCrumbs()
            // console.log(lastCrumb)
            let item = {
              listId: this.listId,
              itemId: lastCrumb.itemId
            }
            this.loading = true
            Promise.all([this.GET_ITEM(item), this.GET_DOCUMENTS(item)]).then((response) => {
              // update breadcrumbs with new itemInfo
              let replacementCrumb = {
                listId: this.listId,
                itemId: lastCrumb.itemId,
                childCount: response[0].folder.childCount,
                name: response[0].name
              }
              this.fileBreadCrumbs[this.fileBreadCrumbs.length - 1] = replacementCrumb
              this.loading = false
            })
            this.selectedRows = []
          } else {
            this.moveRecursiveParticle(itemsToMove, i + 1)
          }
        }, error => {
          itemsToMove[i].loadingStatus = 'error'
          itemsToMove[i].progressStatus = 'exception'
          itemsToMove[i].progressColor = '#FF3232'
          itemsToMove[i].percentCompleted = 100
          if (error.response) {
            itemsToMove[i].statusMessage = error.response.data.message
          }

          if (i === itemsToMove.length - 1) {
            this.loading = false
          } else {
            this.moveRecursiveParticle(itemsToMove, i + 1)
          }
        })
      }
    },
    created: function () {
      this.initialize()
    },
    // mounted: function() {
    //   this.initialize()
    // },
    computed: {
      // ...mapGetters('user/', ['GET_ROLE']),
      // ...mapState('user/', ['currentClient']),
      ...mapState('onedrive/', ['documents', 'fileAccept', 'selectedItemId', 'nextLink']),
      loadMoreActive: {
        get: function () {
          return ((this.nextLink !== '') && (this.nextLink !== null))
        }
      },
      isMoveDisabled: {
        get: function () {
          let item = this.getLastItemFromBreadCrumbs()
          return ((item) && (this.selectedItemId === item.itemId))
        }
      }
    },
    watch: {
      itemId() {
        this.initialize()
      }
    }
  }
</script>

<style scoped>
  >>>.document-item .item:hover {
    color: rgb(109, 207, 246);
    width: 100%;
    cursor: pointer;
  }

  >>>.document-item-selected .item {
    color: rgb(109, 207, 246);
    width: 100%;
    cursor: pointer;
    background-color: #f5f7fa;
  }

  >>>.cell {
    word-break: normal !important
  }

  #documentTable>>>tr>td:first-child .cell,
  #documentTable>>>tr>th:first-child .cell {
    text-overflow: clip;
  }

  #documentTable {
    /* max-height: 55vh;
    overflow-y: auto; */
    width: 100%;
    margin-top: 20px;
  }

  #documentTable::before {
    height: 0px !important;
  }

  #documentTable>>>.el-checkbox__input.is-checked .el-checkbox__inner {
    /*background-color: #1c3c5f;
    border-color: #1c3c5f; */
  }

  #documentTable>>>input.el-input__inner {
    height: 25px !important;
  }

  #documentTable>>>.el-checkbox__inner {
    border-radius: 10px;
  }

  >>>.documentActionMenuIcon {
    margin: 0px 5px 0px 0px;
  }

  >>>.ellipsesIcon {
    font-size: 18px;
    color: #606266;
    float: left;
    margin: 3px 0px 0px 0px;
    padding: 0px 3px 0px 3px;
    border: 1px solid transparent;
    border-radius: 100px;
    cursor: pointer;
  }

  >>>.ellipsesIcon:hover {
    font-size: 18px;
    color: #1c3c5f;
    float: left;
    margin: 3px 0px 0px 0px;
    padding: 0px 3px 0px 3px;
    border: 1px solid #1c3c5f;
    border-radius: 100px;
    cursor: pointer;
  }

  >>>.showDocItem {
    display: block;
  }

  >>>.hideDocItem {
    display: none;
  }

  /* ICON CLASSES */
  >>>.folderIcon {
    font-size: 36px;
    /* color: #f9e4b7; */
    color: #fadfad;
    float: left;
    margin: 2px 0px 0px 0px;
  }

  >>>.docName {
    float: left;
    margin: 3px 0px 0px 0px;
  }

  >>>.docIcon {
    font-size: 30px;
    color: rgba(0, 86, 149, .7);
    float: left;
    margin: 0px 0px 0px 0px;
  }

  .actionIcons {
    font-size: 16px;
    color: rgba(0, 86, 149, .7);
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }

  >>>.mdi-file-document-box-outline {
    color: #547b93;
  }

  >>>.mdi-image {
    color: #03284d;

  }

  >>>.mdi-file-pdf-box {
    color: #ff0021;
  }

  >>>.mdi-file-word-box {
    color: #2d5794;
  }

  >>>.mdi-file-excel-box {
    color: #2e7048;
  }

  >>>.mdi-file-cabinet {
    color: #7c4379;
  }

  >>>.mdi-outlook {
    color: #0070c0;
  }

  >>>.mdi-onenote {
    color: #80397B;
  }

  /* ACTION MENU */

  .actionButtonsIcon {
    font-size: 18px;
  }

  .actionButtons li {
    margin: 5px 0px 5px 0px;
    cursor: pointer;
  }

  .actionButtons li:first-child {
    margin: 0px 0px 5px 0px;
  }

  .actionButtonsItem:hover {
    background: #005695;
    padding: 4px 5px 4px 5px;
    width: 150px;
    border-radius: 30px;
    color: #ffffff;
    font-weight: normal;
  }

  .actionButtonsItemActive {
    background: #005695;
    padding: 4px 5px 4px 5px;
    width: 150px;
    text-align: center;
    border-radius: 30px;
    color: #ffffff;
    font-weight: normal;
  }

  .actionButtonsItem {
    background: transparent;
    padding: 4px 5px 4px 5px;
    width: 150px;
    border-radius: 30px;
    color: #005695;
    font-weight: normal;
  }

  .actionButtonsItem span {
    margin-left: 20px;
  }

  /* DOCUMENT TABLE STATS */
  #documentTableStats {
    padding: 0px 0px 0px 0px;
    margin: 7px 0px 0px 15px;
  }

  #documentTableStats p {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    font-size: 12px;
    font-weight: normal;
    color: #606266;
  }
</style>
